import { all, call, put, takeLatest } from "redux-saga/effects";
import { AxiosCall } from "../../../utils/axios";
import * as actions from "./actions";

function* fetchBrevoFolders() {
    try {
        const result = yield call(AxiosCall, '/brevo/get_all_folders/');
        yield put(actions.fetchBrevoFoldersSuccess(result.data.results));
    } catch (e) {
        yield put(actions.fetchBrevoFoldersFailure(e));
    }
}

export default function* rootSaga() {
    yield all([
        // watchers folders
        takeLatest(actions.FETCH_BREVO_FOLDERS.REQUEST, fetchBrevoFolders),
    ])
}